jQuery(function( $ ) {
    "use strict"

    vector.toggleBlock();
    vector.mixedMediaSliderBlock();
    vector.logoSliderBlock();
    vector.timelineBlock();
    vector.expandCollapseBlock();
    vector.newsAndInsightsSlider();
    vector.marketFaqAccordion();

    // Map Logic
    if ( $( '#map__wrap' ).length ) {

        // Set up the map with class active
        $( '#sales__results [data-states]' ).each(function() {

            let stateList = $( this ).data( 'states' );
            if ( ! stateList ) return;

            let states = stateList.split(',').map( s => $.trim( s.toUpperCase() ) );

            states.forEach(function( state ) {
                $( '#' + state ).addClass( 'active' );
            });

        });

        var $mapStates = $( '#map__svg path.active' );

        $mapStates.each( function() {
            var state = this.id;

            $( this )
                .attr( 'role', 'button' )
                .attr( 'tabindex', '0' )
                .attr( 'aria-label', 'View sales representative details for ' + state );
        } );

        // Panel Logic
        var $popup = $( '#map__popup' );
        var $closeButton = $popup.find( '.panel__close' );
        var $mapScreen = $( '#map__screen' );
        var popupOpener = null;

        var closePopup = function() {
            $popup.fadeOut( 300 );
            $popup.removeClass( 'active' );

            if ( popupOpener && popupOpener.isConnected ) {
                popupOpener.focus();
            }
        };

        // Close popup when clicking the close button or map screen
        $closeButton.add( $mapScreen ).on( 'click', function() {
            closePopup();
        });

        $popup.on( 'keydown', function( event ) {
            if ( event.key === 'Escape' ) {
                event.preventDefault();
                closePopup();
            }
        });

        $mapStates.on( 'keydown.vectorMapPopup', function( event ) {
            if ( event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' ) {
                event.preventDefault();
                $( this ).trigger( 'click' );
            }
        });

        $mapStates.on( 'click.vectorMapPopup', function() {
            popupOpener = this;

            // Reset Directory List
            filterPanels( 'all' );

            // Clear previous popup content
            const popupWrap = $( '#map__popup .panel__content' );
            popupWrap.empty();

            // If there are Sales Reps for the state
            if ( $( this ).hasClass( 'active' ) ) {
                const state = $( this ).attr( 'id' );

                // Loop through all sales rep panels
                $( '.map__panel' ).each(function() {

                    const states = $( this ).data( 'states' ).split( ',' );

                    if ( states.includes( state ) ) {
                        // Clone the panel so the original stays in the list
                        const repClone = $( this ).clone( true, true );
                        popupWrap.append( repClone );
                    }
                });

            // If there are no Sales Reps for the state
            } else {
                $( '.map__panel.inside' ).each(function() {
                    // Clone the panel so the original stays in the list
                    const repClone = $( this ).clone( true, true );
                    popupWrap.append( repClone );
                });
            }

            // Open the popup
            $popup.fadeIn( 300 );
            $popup.addClass( 'active' );

            window.setTimeout( function() {
                var $heading = $popup.find( '.panel__content .map__panel h3' ).first();

                if ( $heading.length ) {
                    $heading.attr( 'tabindex', '-1' ).trigger( 'focus' );
                } else {
                    $closeButton.trigger( 'focus' );
                }
            }, 0 );
        });

        const $select = $( '#state__filter' );
        const $panels = $( '.map__panel' );

        function filterPanels( state ) {
            $panels.each( function() {

                // Special case: inside
                if ( state === 'inside' ) {
                    $( this ).toggle( $( this ).hasClass( 'inside' ) );
                    return;
                }

                const states = ( $( this ).data( 'states' ) || '' )
                    .toString()
                    .toUpperCase()
                    .replace( /\s+/g, '' )
                    .split( ',' );

                const show = state === 'all' || states.indexOf( state ) !== -1;

                $( this ).toggle( show );
            });
        }

        // On dropdown change
        $select.on( 'change', function() {
            filterPanels( this.value );
        });

        // Initial state
        filterPanels( 'all' );

    }

});



// WEBPACK FOOTER //
// ./resources/assets/scripts/interior.js